module.exports = __webpack_public_path__ + "static/media/benefits5.8e627984.webp";